import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'Upload',
      title: 'One-Shot Case Intake',
      description: 'Upload up to 30 images, optional PDFs, and structured text fields in a single submission. No back-and-forth required.',
      benefits: ['Multi-file drag & drop', 'Automatic validation', 'Progress tracking']
    },
    {
      icon: 'Cpu',
      title: 'Latest AI Models Pipeline',
      description: 'Security-first architecture suitable for professional and enterprise use, implementing modern safeguards to protect sensitive case data.',
      benefits: ['Intelligent triage', 'Confidence scoring', 'Standards-aligned output']
    },
    {
      icon: 'FileText',
      title: '15-Section Reports',
      description: 'Comprehensive preliminary reports covering all aspects from cover page through appendix, fully NFPA 921 compliant.',
      benefits: ['Executive summary', 'Origin & cause analysis', 'Professional PDF export']
    },
    {
      icon: 'Image',
      title: 'Image Annotation Engine',
      description: 'AI-powered overlay system with arrows, boxes, and labels on original images. No hallucinated content, only real evidence.',
      benefits: ['Visual evidence marking', 'Toggle annotations', 'High-resolution exports']
    },
    {
      icon: 'Users',
      title: 'Expert Marketplace',
      description: 'Connect with vetted fire forensics experts for human review. Credential verification, escrow payments, and in-app messaging.',
      benefits: ['Verified credentials', 'Secure payments', 'Anti-circumvention protection']
    },
    {
      icon: 'Shield',
      title: 'Enterprise Security',
      description: 'Built with a security-first architecture designed to protect sensitive case data at every layer.',
      benefits: ['Encrypted data transit', 'Mandatory multi-factor authentication', 'Role-based access controls']
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Powerful Features for Complete Analysis
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to conduct preliminary fire forensics investigations with AI assistance and expert collaboration.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-6 md:p-8 transition-smooth hover:shadow-elevation-lg hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-primary/10 rounded-xl flex items-center justify-center mb-6">
                <Icon name={feature?.icon} size={28} className="text-primary" />
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-3">
                {feature?.title}
              </h3>
              
              <p className="text-sm md:text-base text-muted-foreground mb-4">
                {feature?.description}
              </p>
              
              <div className="space-y-2">
                {feature?.benefits?.map((benefit, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <Icon name="Check" size={16} className="text-success flex-shrink-0" />
                    <span className="text-sm text-foreground">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;